<div class="sakura-container">
    <div class="tree-1"></div>
    <div class="tree-2"></div>
</div>